import { io } from "socket.io-client";
import config from "services/config";

// El socket vive en el origen del backend, namespace `/portal`.
// `config.url` incluye el prefijo `/api`; se lo quitamos.
function getOrigin() {
  return config.url.replace(/\/api\/?$/, "");
}

let socket = null;

export function connectPortalSocket() {
  if (socket && socket.connected) return socket;

  const portalData = JSON.parse(localStorage.getItem("userdata:portal") || "null");
  const token = portalData?.token;
  if (!token) return null;

  socket = io(`${getOrigin()}/portal`, {
    auth: { token },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: 5,
  });

  socket.on("connect_error", (err) => {
    console.warn("[portal-socket] connect_error:", err.message);
  });

  return socket;
}

export function disconnectPortalSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function getPortalSocket() {
  return socket;
}
